import React from 'react'
import EditProductsCategoryContainer from '../../../../Components/Category/EditProductsCategoryContainer/EditProductsCategoryContainer'
import Layout from '../../Layout'

const EditProductsCategory = () => {
  return (
    <Layout><EditProductsCategoryContainer/></Layout>
  )
}

export default EditProductsCategory